import { Injectable } from '@angular/core';
import {
  ResourceAction,
  ResourceCRUD,
  ResourceMethod,
  ResourceParams
} from 'ng2-resource-rest';
import { RequestMethod } from '@angular/http';
import { DateString } from './types';
import { Images } from '../admin/preview/preview.component';

export interface IReceiptInput {
  date        : DateString|Date;
  img         : Images[];
  fullAmount  : number;
  amount      : number;
  vat         : number;
  vatAmount   : number;
  rows        : IReceiptRow[];
  showRows?   : boolean;
  dirty?      : boolean;
  tags        : string[];
}

export interface IReceipt extends IReceiptInput{
  id? : number;
}

export interface IReceiptRow {
  id?       : number;
  name      : string;
  amount    : number;
  vat       : number;
  vatAmount : number;
}

@Injectable()
@ResourceParams({
  url: '/api/receipt'
})
export class Receipt extends ResourceCRUD<IReceiptInput, IReceipt, IReceipt> {

  public static newReceipt() : IReceiptInput {
    return {
      date        : '',
      img         : [],
      fullAmount  : 0,
      amount      : 0,
      vat         : 24,
      vatAmount   : 0,
      rows        : [],
      tags        : []
    };
  }

  public static newRow() : IReceiptRow {
      return {
        name        : '',
        amount      : 0,
        vat         : 24,
        vatAmount   : 0
      };
  }

  @ResourceAction({
      path: '/image-list',
      method: RequestMethod.Get
  })
  public imageList: ResourceMethod<any, {images : string[]}>;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/receipt.ts